/* @flow */

import * as Yup from 'yup'

import WebshopLinkButtonWidgetSettings from './WebshopLinkButtonWidgetSettings'
import WebshopLinkButtonWidget from './WebshopLinkButtonWidget'
import { defaultLinkButtonItem } from './shared'

type WidgetSettings = {
  button_style: string | null,
  button_size: 'xsmall' | 'small' | 'normal' | 'large' | 'xlarge',
  stack_mode: 'stacked' | 'side_by_side',
  space_between_each: number,

  number_of_link_buttons: number,
  link_buttons: Array<{
    button_text: string,
    link_type: 'navigation_link' | 'webshop_page' | 'manual_url',
    navigation_link_id: number | null,
    webshop_page_id: number | null,
    manual_url: string,
  }>,
}

const widget = {
  component: WebshopLinkButtonWidget,
  settings: WebshopLinkButtonWidgetSettings,

  available_children: [],
  label: 'Link button(s)',

  default_settings: ({
    button_style: null,
    button_size: 'normal',
    stack_mode: 'stacked',
    space_between_each: 10,

    number_of_link_buttons: 1,
    link_buttons: [
      {
        ...defaultLinkButtonItem,
      },
    ],
  }: WidgetSettings),

  default_style: {},

  // TODO: add validation
  settings_validation: Yup.object().shape({
    data: Yup.object().shape({
      // button_text: Yup.string().required('Button text is required'),
      // url: Yup.string().when('link_type', {
      //   is: 'url',
      //   then: Yup.string().required('URL is required'),
      // }),
      stack_mode: Yup.string().oneOf(['stacked', 'side_by_side']),
      space_between_each: Yup.number()
        .typeError('Must be integer')
        .required('Must be integer')
        .integer('Must be integer')
        .min(0, 'Must be 0 or more'),
    }),
  }),
}

export default widget
